import { Box, Step, StepIconProps, StepLabel, Stepper } from "@mui/material";
import { clsx } from "clsx";
import { observer } from "mobx-react";
import React from "react";
import { useLocation } from "react-router-dom";
import { ReactComponent as SideBarActive } from "@common/images/SideBarActive.svg";
import { ReactComponent as StepIcon } from "@common/images/StepIcon.svg";
import { HtmlTooltip } from "../Tooltip";
import useEmotionStyles from "../../../styles/shared/useEmotionStyles";
import { SideBarStyle } from "./SideBarStyle";

// 예시로 ActiveIcon을 감싸는 래핑 컴포넌트
const WrappedSideBarActive: React.FC<StepIconProps> = (props: any) => {
	return <SideBarActive {...props} />;
};

// 다른 아이콘도 동일하게 래핑
const WrappedStepIcon: React.FC<StepIconProps> = (props: any) => {
	return <StepIcon {...props} />;
};

type Props = {
	projectCode?: string;
	children: any[];
	onClick: (link: string) => void;
	expanded: boolean;
	activeStates?: any;
};

function ChildMenuComponent(props: Props) {
	const classes = useEmotionStyles(SideBarStyle);
	const { pathname } = useLocation();
	const { projectCode, children, expanded, onClick, activeStates } = props;
	const [subMenu, setSubMenu] = React.useState(children);
	const disabled = !projectCode || projectCode === "undefined";

	const handleClick = (child: any) => {
		if (!disabled && !child.disabled) {
			props.onClick(child.link);
		}
	}

	const isActive = (child: any) => {
		const oldCondition = (!disabled || child.id === 'info') && activeStates[child.id];
		const viewChildIdCondition = (!disabled && child.id === 'view');

		return oldCondition || viewChildIdCondition;
	}
	
	const isCurrent = (child: any) => {
		return pathname.includes(child.urlPrefix)
	}

	React.useEffect(() => {
		let trigger = false;
		const temp = children.map(child => {
			if (child.id === "view") child = { ...child, disabled: trigger, view: activeStates.rubric };
			else child = { ...child, disabled: trigger };

			if (trigger || (!child.skip && !activeStates[child.id])) {
				trigger = true;
			}
			return child;
		});
		setSubMenu(temp);
	}, [children, activeStates]);

	return (
		<Box className={clsx(classes.stepperBox, expanded ? classes.stepperBoxOpen : classes.stepperBoxClose)}>
			<Stepper
				activeStep={-1}
				orientation="vertical"
				className={classes.stepper}
			>
				{subMenu
					.filter((child) => child.view !== false)
					.map((child, index) => (
						<Step key={child.id} className={classes.step}>
							<StepLabel
								className={clsx(
									classes.stepLabel,
									isCurrent(child) ? classes.stepLabelCurrent : undefined,
									isActive(child) ? classes.stepLabelActive : classes.stepLabelInactive,
									child.disabled ? classes.stepLabelDisabled : undefined
								)}
								StepIconComponent={isActive(child) ? WrappedSideBarActive : WrappedStepIcon}
								onClick={() => handleClick(child)}
							>
								<HtmlTooltip title={child.label} disableHoverListener={expanded}>
									<Box className={classes.stepLabelText}>
										{expanded ? child.label : ""}
									</Box>
								</HtmlTooltip>
							</StepLabel>
						</Step>
					))}
			</Stepper>
		</Box>
	);
}

export default observer(ChildMenuComponent);
